/**
 * contains locale specific translations
 */
const locale = {
  de_DE: {
    'offer': 'Angebote',
    'Clear All': 'Alle Filter löschen',
    'No Filter Options': 'Keine Filtermöglichkeit',
    'All Prices': 'Alle Preise',
    'All Products': 'Alle Produkte',
    'Above': 'Über',
    '& above': '& mehr',
    'EUR': '€',
    'Reduced Only for a Short Time': 'Nur für kurze Zeit reduziert',
    'You Save': 'Du sparst',
    'Free Shipping': 'Portofrei',
    'Tip!': 'Tipp!',
    'Customers rated this product with an average of %s% satisfaction.': 'Kunden haben dieses Produkt mit durchschnittlich %s% Zufriedenheit bewertet',
    'Out of stock': 'Leider ausverkauft',
    'Best Before %s': 'Mindestens haltbar bis %s',
    'Shortened shelf life': 'Verkürzte Haltbarkeit',
    'Add to Cart': 'In den Warenkorb',
    'Go to Product': 'Zum Produkt',
    'First Page': 'Erste Seite',
    'Last Page': 'Letzte Seite',
    'Previous Page': 'Vorherige Seite',
    'Next Page': 'Nächste Seite',
    'Page %s': 'Seite %s',
    'from': 'von',
    'Products': 'Produkten',
    'for': 'für',
    'Selected Filters': 'Ausgewählte Filter',
    'Filter': 'Filtern',
    'No Results': 'Keine Ergebnisse',
    '1 Product': '1 Produkt',
    'Show %s Results': 'Zeige %s Ergebnisse',
    'Close Filters': 'Filter schliessen',
    'Show More Options': 'Mehr Optionen anzeigen',
    'Show Less Options': 'Weniger Optionen anzeigen',
    'Category': 'Kategorie',
    'Manufacturer': 'Marken',
    'Dosage Form': 'Darreichungsform',
    'Flavor': 'Geschmack',
    'Price': 'Preis',
    'Diet': 'Ernährungsform',
    'Distinction': 'Auszeichnung',
    'Free of': 'Frei von',
    'Time of Intake': 'Einnahmezeitpunkt',
    'Product Size': 'Produktgröße',
    'Skin Type': 'Hauttyp',
    'Age Group': 'Altersgruppe',
    'Content': 'Inhalt',
    'Sort': 'Sortieren',
    'Ratings': 'Bewertung',
    'More Options': 'Weitere Auswahlmöglichkeiten',
    'NEW': 'NEU',
    'Sale': 'Sale',
    'Vorteilspakete': 'Vorteilspakete',
  },
  nl_NL: {
    'offer': 'Aanbiedingen',
    'Clear All': 'alles wissen',
    "Abnehmen":"Afvallen",
    "Essen & Trinken":"Eten & Drinken",
    "Accessoires":"Accessoires",
    "Aminosäuren":"Aminozuren",
    "Anti Aging":"Anti-veroudering",
    "Antioxidantien":"Antioxidanten",
    "Anwendungsgebiete":"Toepassingsgebieden",
    "Aufbewahrung":"Opslag",
    "Aufstrich":"Smeersel",
    "Backzutaten":"Bakingrediënten",
    "Bekleidung":"Kleding",
    "Blase / Leber":"Blaas / Lever",
    "Blocker":"Blokkers",
    "Booster":"Boosters",
    "Creatin":"Creatine",
    "Darm":"Darmen",
    "Energie":"Energie",
    "Fettsäure":"Vetzuren",
    "Fitnesskleingeräte":"Fitnessaccessoires",
    "Gelenke":"Gewrichten",
    "Gesichtspflege":"Gezichtsverzorging",
    "Getreide":"Granen",
    "Haare Haut":"Haar & Huid",
    "Herz Kreislauf":"Hart & Bloedsomloop",
    "Immunsystem":"Immuunsysteem",
    "Kaffeeprodukte":"Koffieproducten",
    "Kakaoprodukte":"Cacaoproducten",
    "Kochen":"Koken",
    "Kohlenhydrate":"Koolhydraten",
    "Liebesleben":"Liefdesleven",
    "Mahlzeitenersatz":"Maaltijdvervanger",
    "Milchersatz":"Melkvervanger",
    "Mineralstoffe":"Mineralen",
    "Müsli Brei Porridge":"Muesli, Pap & Havermout",
    "Nerven":"Zenuwen",
    "Öle":"Oliën",
    "Protein":"Eiwit",
    "Recovery":"Herstel",
    "Sättigung":"Verzadiging",
    "Schlaf":"Slaap",
    "Snacks":"Snacks",
    "Sonstiges":"Overig",
    "Stoffwechsel":"Stofwisseling",
    "Stoffwechsel Energie":"Stofwisseling & Energie",
    "Superfood":"Superfood",
    "Tee":"Thee",
    "Vitalität":"Vitaliteit",
    "Vitamine":"Vitaminen",
    "Zuckerersatz":"Suikervervanger",
    "Gesundheit":"Gezondheid",
    "Naturkosmetik":"Natuurlijke cosmetica",
    "Schönheit":"Schoonheid",
    "Service":"Service",
    'Hauptkategorie':'Hoofdcategorie',
    'Unterkategorie':'Subcategorie',
    'No Filter Options': 'geen filter optie',
    'All Prices': 'alle prijzen',
    'All Products': 'Alle producten',
    'Above': 'boven',
    'Above ': 'boven ',
    'Above €': 'boven',
    'Above EUR': 'boven',
    'Reduced Only for a Short Time': 'slechts voor een korte tijd verlaagd',
    'You Save': 'u bespaart',
    'Free Shipping': 'gratis verzending',
    'Tip!': 'Tip!',
    'Customers rated this product with an average of %s% satisfaction.': 'Klanten hebben dir product beoordeeld met een gemiddelde van %s% tevredenheid.',
    'Best Before %s': 'beste voor %s',
    'Shortened shelf life': 'verkorte houdbaarheid',
    'Add to Cart': 'In winkelmandje',
    'Go to Product': 'Product weergeven',
    'First Page': 'eerste pagina',
    'Last Page': 'laatste pagina',
    'Previous Page': 'vorige pagina',
    'Next Page': 'volgende pagina',
    'Page %s': 'pagina %s',
    'from': 'van',
    'Products': 'Producten',
    'for': 'voor',
    'Selected Filters': 'geselecteerde filters',
    'Filter': 'filter',
    'Show %s Results': '%s resultaten weergeven',
    'Close Filters': 'sluit filters',
    'Show More Options': 'meer opties weergeven',
    'Show Less Options': 'minder opties weergeven',
    'Category': 'Categorie',
    'Manufacturer': 'Merken',
    'Dosage Form': 'Formulering',
    'Flavor': 'Smaak',
    'Hauptzutat / Wirkstoff': 'Hoofdbestanddeel / Werkzame',
    'Price': 'Prijs',
    'Diet': 'Voedings vorm',
    'Distinction': 'Onderscheiding',
    'Free of': 'Vrij van',
    'Time of Intake': 'Tijdstip van inname',
    'Product Size': 'Product grootte',
    'Skin Type': 'Huidtype',
    'Age Group': 'Leeftijd',
    'Content': 'Inhoud',
    'Sort': 'Sorteren',
    'Relevanz': 'Relevantie',
    'Niedrigster Preis': 'Laagste prijs',
    'Höchster Preis': 'Hoogste prijs',
    'No Results': 'Geen resultaten',
    'More Options': 'Meer opties',
    'Out of stock': 'Uitverkocht',
    'NEW': 'NIEUW',
    'Ratings': 'Waarderingen',
    'Sale': 'Sale',
    'Vorteilspakete': 'Spaarpakketten',
  }
};

/**
 * contains store specific translations
 */
export const storeSpecificTranslations = {
  vomachterhof: {
    "Distinction": "Qualität",
  },
};

export default locale;
